import { Card, Col, Row } from "antd";
import React, { useEffect } from "react";
import { MyBreadcrumb, MyButton } from "../../../../components";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { selectStore } from "../../../../store/selector";
import { CardItemSpan, CardItemTitle } from "./index.style";
import { getPsychologistScheduleByID, getPsychologistWorkByOne } from "../../../../store/pages/psychologist/actions";
import { SCHEDULE_WEEKS } from "../../../../constants/main";

export const PsychologistWorkSubView = React.memo(() => {
  const dispatch = useDispatch();

  const { id } = useParams()
  const {
    psychologist: {
      psychologistWorkOne
    }
  }: RootState = useSelector(selectStore)

  useEffect(() => {
    if (id) {
      dispatch(getPsychologistWorkByOne(id))
    }
  }, [id])


  return (
    <>
      <MyBreadcrumb isBack title="График работы" />
      <Row justify={'center'}>
        <Col span={20}>
          <Card title={psychologistWorkOne?.data?.type} style={{ width: "100%" }} loading={psychologistWorkOne?.loading}>
            {/* <CardItemTitle> Вид деятельности: <CardItemSpan>{psychologistWorkOne?.data?.type}</CardItemSpan> </CardItemTitle> */}
            {/* <CardItemTitle> Время работы: <CardItemSpan>{psychologistWorkOne?.data?.start_time} - {psychologistWorkOne?.data?.end_time}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Перерыв: <CardItemSpan>{psychologistWorkOne?.data?.break_start_time} - {psychologistWorkOne?.data?.break_end_time}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Рабочие дни: <CardItemSpan>{psychologistWorkOne?.data?.weekdays?.map((el: any, indexEl: any) => {
              let last = indexEl == psychologistWorkOne?.data?.weekdays.length - 1 ? " " : ", ";
              return SCHEDULE_WEEKS().find((elFind: any) => el === elFind.value)?.label + last;
            })}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Примечание: <CardItemSpan>{psychologistWorkOne?.data?.note}</CardItemSpan> </CardItemTitle> */}
          </Card>
        </Col>
      </Row>
    </>

  )
})